module.exports = __webpack_public_path__ + "static/media/Curriculum.6857028e.jpg";